module.exports = __webpack_public_path__ + "img/MemeETC (15).3ebceca2.jpeg";